import { Flex, Paper, Pill, ScrollArea, Text } from '@mantine/core';

import type { IEquipmentModel } from '../../../../../../../shared/apis/ai-agent/model/types';

interface IPropsLinkedModels {
  data: IEquipmentModel[];
  onRemove: (modelId: number) => void;
}

export default function LinkedModels(props: IPropsLinkedModels) {
  const { data, onRemove } = props;
  return (
    <Paper p="sm" withBorder>
      <Flex gap={4}>
        <Text fw={500}>선택된 모델</Text>
        <Text>({data.length})</Text>
      </Flex>
      <ScrollArea.Autosize mah={80} mt="sm" scrollbarSize={6}>
        <Flex gap="xs" wrap="wrap">
          {data && data.length > 0 ? (
            data.map((model) => (
              <Pill size="md" key={model.modelId} withRemoveButton onRemove={() => onRemove(model.modelId)}>
                {`${model.assignedName}(${model.model})`}
              </Pill>
            ))
          ) : (
            <Text size="sm">연동된 모델이 없습니다.</Text>
          )}
        </Flex>
      </ScrollArea.Autosize>
    </Paper>
  );
}
